const createCourseFromCourseElement = (courseElement, categoriesTable, companyId) => {
  let courseid = findElementinSubElementsByName(courseElement.elements, "CourseID");
  let coursename = findElementinSubElementsByName(courseElement.elements, "Label");
  let coursetype = findElementinSubElementsByName(courseElement.elements, "Type");
  let text1 = findElementinSubElementsByName(courseElement.elements, "Text1");
  let text2 = findElementinSubElementsByName(courseElement.elements, "Text2");
  let text3 = findElementinSubElementsByName(courseElement.elements, "Text3");
  let cost = findElementinSubElementsByName(courseElement.elements, "Cost");
  let duration = findElementinSubElementsByName(courseElement.elements, "Duration");
  let currencySymbol = findElementinSubElementsByName(courseElement.elements, "CurrencySymbol");
  let categoryIds = findElementinSubElementsByName(courseElement.elements, "CategoryIDs");
  let level = (/<h3\sclass="sectHeading">Level<\/h3><p\sclass="sectPara">(.*?)<\/p>/gi).exec(text1?.elements?.[0]?.text)
  let provider = (/<h3\sclass="sectHeading">Provided\sBy<\/h3><p\sclass="sectPara">(.*?)<\/p>/gi).exec(text1?.elements?.[0]?.text)
  let audience = (/<h3\sclass="sectHeading">Intended\sAudience<\/h3><p\sclass="sectPara">(.*?)<\/p>/gi).exec(text1?.elements?.[0]?.text)

  let course = {
    courseid: (courseid != null && courseid.elements !== undefined ? courseid.elements[0].text : ""),
    companyId: companyId,
    coursename: (coursename != null && coursename.elements !== undefined ? coursename.elements[0].text : ""),
    coursetype: (coursetype != null && coursetype.elements !== undefined ? translateType(coursetype.elements[0].text) : ""),
    text1: (text1 != null && text1.elements !== undefined ? text1.elements[0].text : ""),
    text2: (text2 != null && text2.elements !== undefined ? text2.elements[0].text : ""),
    text3: (text3 != null && text3.elements !== undefined ? text3.elements[0].text : ""),
    cost: (cost != null && cost.elements !== undefined ? translateCost(cost.elements[0].text) : ""),
    duration: (duration != null && duration.elements !== undefined ? duration.elements[0].text.split('.')[0] : ''),
    currencySymbol: (currencySymbol != null && currencySymbol.elements !== undefined ? currencySymbol.elements[0].text : ""),
    categories: (categoryIds != null && categoryIds.elements !== undefined && categoriesTable)
      ? translateCategories(categoryIds, categoriesTable)
      : "",
    level: (level && level[1]) ? removeHtmlTags(level[1]).trim() : "",
    provider: (provider && provider[1]) ? removeHtmlTags(provider[1]).trim() : "",
    audience: (audience && audience[1]) ? removeHtmlTags(audience[1]).trim() : "",
  }
  if (!!companyId) {
    course.companyId = companyId
  }
  return course;
}

const createDatesFromCourseElement = (courseElement) => {
  let dates = [];
  if (courseElement.elements !== undefined) {
    courseElement.elements.forEach(dateElement => {
      let courseDateId = findElementinSubElementsByName(dateElement.elements, "CourseDateID");
      let courseId = findElementinSubElementsByName(dateElement.elements, "CourseID");
      let startDateString = findElementinSubElementsByName(dateElement.elements, "StartDateString");
      let startDate = findElementinSubElementsByName(dateElement.elements, "StartDate");
      let startTimeString = findElementinSubElementsByName(dateElement.elements, "StartTimeString");
      let endDateString = findElementinSubElementsByName(dateElement.elements, "EndDateString");
      let endDate = findElementinSubElementsByName(dateElement.elements, "EndDate");
      let endTimeString = findElementinSubElementsByName(dateElement.elements, "EndTimeString");
      let status = findElementinSubElementsByName(dateElement.elements, "Status");
      let cost = findElementinSubElementsByName(dateElement.elements, "Cost");
      let currencySymbol = findElementinSubElementsByName(dateElement.elements, "CurrencySymbol");
      let bookNowURL = findElementinSubElementsByName(dateElement.elements, "BookNowURL");
      let venueIds = findElementinSubElementsByName(dateElement.elements, "VenueIDs");
      let trainerIds = findElementinSubElementsByName(dateElement.elements, "TrainerIDs");

      let date = {
        courseDateId: (courseDateId != null && courseDateId.elements !== undefined ? courseDateId.elements[0].text : ""),
        courseId: (courseId != null && courseId.elements !== undefined ? courseId.elements[0].text : ""),
        startDateString: (startDateString != null && startDateString.elements !== undefined ? startDateString.elements[0].text : ""),
        startDate: (startDate != null && startDate.elements !== undefined ? startDate.elements[0].text : ""),
        endDateString: (endDateString != null && endDateString.elements !== undefined ? endDateString.elements[0].text : ""),
        endDate: (endDate != null && endDate.elements !== undefined ? endDate.elements[0].text : ""),
        startTimeString: (startTimeString != null && startTimeString.elements !== undefined ? startTimeString.elements[0].text : ""),
        endTimeString: (endTimeString != null && endTimeString.elements !== undefined ? endTimeString.elements[0].text : ""),
        status: (status != null && status.elements !== undefined ? status.elements[0].text : ""),
        cost: (cost != null && cost.elements !== undefined ? cost.elements[0].text : ""),
        currencySymbol: (currencySymbol != null && currencySymbol.elements !== undefined ? currencySymbol.elements[0].text : ""),
        bookNowURL: (bookNowURL != null && bookNowURL.elements !== undefined ? bookNowURL.elements[0].text : ""),
        venueIds: (venueIds != null && venueIds.elements !== undefined ? venueIds.elements.map(venueEl => { return venueEl.elements[0].text }) : []),
        trainerIds: (trainerIds != null && trainerIds.elements !== undefined ? trainerIds.elements.map(trainerEl => { return trainerEl.elements[0].text }) : []),
      };
      dates.push(date);
    });
  }

  return dates;
}

const createCategoriesFromCourseElement = (courseElement) => {
  let categories = [];
  if (courseElement.elements !== undefined) {
    courseElement.elements.forEach(categoryElement => {
      let categoryId = findElementinSubElementsByName(categoryElement.elements, "CategoryID");
      let name = findElementinSubElementsByName(categoryElement.elements, "Label");
      let address = findElementinSubElementsByName(categoryElement.elements, "Address");
      let county = findElementinSubElementsByName(categoryElement.elements, "County");
      let postcode = findElementinSubElementsByName(categoryElement.elements, "Postcode");
      let longitude = findElementinSubElementsByName(categoryElement.elements, "Longitude");
      let latitude = findElementinSubElementsByName(categoryElement.elements, "Latitude");

      let category = {
        categoryId: (categoryId != null && categoryId.elements !== undefined ? categoryId.elements[0].text : ""),
        name: (name != null && name.elements !== undefined ? name.elements[0].text : ""),
        address: (address != null && address.elements !== undefined ? address.elements[0].text : ""),
        county: (county != null && county.elements !== undefined ? county.elements[0].text : ""),
        postcode: (postcode != null && postcode.elements !== undefined ? postcode.elements[0].text : ""),
        longitude: (longitude != null && longitude.elements !== undefined ? longitude.elements[0].text : ""),
        latitude: (latitude != null && latitude.elements !== undefined ? latitude.elements[0].text : ""),
      };
      categories.push(category);
    });
  }
  return categories;
}

const createVenuesFromCourseElement = (courseElement) => {
  let venues = [];
  if (courseElement.elements !== undefined) {
    courseElement.elements.forEach(venueElement => {
      let venueId = findElementinSubElementsByName(venueElement.elements, "VenueID");
      let name = findElementinSubElementsByName(venueElement.elements, "Label");
      let address = findElementinSubElementsByName(venueElement.elements, "Address");
      let county = findElementinSubElementsByName(venueElement.elements, "County");
      let postcode = findElementinSubElementsByName(venueElement.elements, "Postcode");
      let longitude = findElementinSubElementsByName(venueElement.elements, "Longitude");
      let latitude = findElementinSubElementsByName(venueElement.elements, "Latitude");

      let venue = {
        venueId: (venueId != null && venueId.elements !== undefined ? venueId.elements[0].text : ""),
        name: (name != null && name.elements !== undefined ? name.elements[0].text : ""),
        address: (address != null && address.elements !== undefined ? address.elements[0].text : ""),
        county: (county != null && county.elements !== undefined ? county.elements[0].text : ""),
        postcode: (postcode != null && postcode.elements !== undefined ? postcode.elements[0].text : ""),
        longitude: (longitude != null && longitude.elements !== undefined ? longitude.elements[0].text : ""),
        latitude: (latitude != null && latitude.elements !== undefined ? latitude.elements[0].text : ""),
      };
      venues.push(venue);
    });
  }

  return venues;
}

const createTrainersFromCourseElement = (courseElement) => {
  let trainers = [];
  if (courseElement.elements !== undefined) {
    courseElement.elements.forEach(trainersElement => {
      let trainerId = findElementinSubElementsByName(trainersElement.elements, "TrainerID");
      let forenames = findElementinSubElementsByName(trainersElement.elements, "Forenames");
      let surname = findElementinSubElementsByName(trainersElement.elements, "Surname");

      let trainer = {
        trainerId: (trainerId != null && trainerId.elements !== undefined ? trainerId.elements[0].text : ""),
        forenames: (forenames != null && forenames.elements !== undefined ? forenames.elements[0].text : ""),
        surname: (surname != null && surname.elements !== undefined ? surname.elements[0].text : ""),
      };
      trainers.push(trainer);
    });
  }
  return trainers;
}

const findElementinSubElementsByName = (rootElement, elementName) => {
  let subElement = null;
  if (rootElement !== undefined) {
    rootElement.forEach(
      (subElements => {
        if (subElements.name === elementName) {
          subElement = subElements;
          return;
        }
      })
    );
  } else {
    return null;
  }
  return subElement;
}

const translateType = (type) => {
  switch (type) {
    case "Class":
      return "In-person";
    case "Web":
      return "Online";
    case "ELearning":
      return "Self-serve";
    case "Documents":
      return "Self-serve";
    case "Knowledge document":
      return "Self-serve"
    default:
      return type;
  }
}

const translateCost = (cost) => {
  if (cost === "" || cost === 0 || cost === '0') {
    return "Free";
  } else {
    return "Chargeable";
  }  
}

const translateCategories = (categoryIds, categories) => {
  let categoryIdsArr = categoryIds.elements[0].text.split(',')
  let result = categoryIdsArr
  .map(categoryId => categories.find(c => c.categoryId === categoryId))
  .filter(c => !!c)
  .map(c => c.name)
  return result.join('. ')
}

const removeHtmlTags = str => {
  var rgx = /(<([^>]+)>)/ig
  return str.replace(rgx, "");
}

const arrayUnique = arr => {
  return arr.filter((value, index, array) => array.indexOf(value) === index)
}
// get all unique values and remove the empty ones
const uniqueOptions = arr => {
  return arrayUnique(arr).filter(str => !!str)
}

module.exports = {
  findElementinSubElementsByName,
  createCourseFromCourseElement, createDatesFromCourseElement,
  createVenuesFromCourseElement, createTrainersFromCourseElement,
  createCategoriesFromCourseElement, translateType, translateCost,
  uniqueOptions
}